<template>
  <div>
    <div :class="'resourceContentContainer'+(data.isFullScreen?' fullscreened':'')" ref="resourceContentContainer">
      <div class="headerContainer">
        <div class="headerText">{{$t('Evaluation')}}</div>
      </div>
      <div
        :class="'singleResource'+(resource.instanceData.isExpanded?' active': '')"
        v-for="(resource, index) in data.items"
        :key="index"
        @click="resourceClicked(resource)"
      >
        <div class="textOuterContainer">
          <div class="textContainer">
            <div class="titleText">
              {{ resource.instanceData.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/resource-content.css";

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
      scrollSaveCount: 0,
    };
  },
  methods: {
    runFirstLoad() {},
    resourceClicked(item) {
        let customEvent = new CustomEvent("openLink", {
          detail: {
            routeLink: item.instanceData.link,
            alertText: item.instanceData.alertText
              ? item.instanceData.alertText
              : null,
          },
        });
        window.dispatchEvent(customEvent);
    },
  },
};
</script>
